export const escapedLocationHash = (hash = location?.hash) => {
  if (!hash) {
    return null;
  }
  const decodedHash = decodeURIComponent(hash.slice(1));
  return `#${window?.CSS?.escape(decodedHash) ?? decodedHash}`;
};
